//#region imports
import React from 'react';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import useMobile from 'hooks/useMobile';
import { ABOUT_LIST, ABOUT_BACKGROUND_IMG } from 'configs/constants';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
//#endregion

interface IProps {
  className?: string;
  currentNumber: number;
  onSubscribe: () => void;
}

const About: React.FC<IProps> = ({ className, currentNumber, onSubscribe }) => {
  const { t } = useTranslation();
  const classes = styles({ src: ABOUT_BACKGROUND_IMG[currentNumber].url });
  const { isMobile } = useMobile();

  return (
    <Container className={ cn(className, classes.root, 'slim', ABOUT_BACKGROUND_IMG[currentNumber].key) } >
      <Box className={ classes.content }>
        <Typography
          variant="h2"
          fontSize={ isMobile ? 26 : 30 }
          color="inherit"
          mb={ isMobile ? 3 : 5 }
          dangerouslySetInnerHTML={ { __html: t(`about.title.${currentNumber}`) } }
        />
        <ul className={ classes.list }>
          { ABOUT_LIST.map(item => <li className={ classes.item } key={ item } dangerouslySetInnerHTML={ { __html: t(item) } } />) }
        </ul>
        <Button onClick={ onSubscribe } className={ classes.button } variant="contained" color="secondary">
          { t('action.subscribe') }
        </Button>
      </Box>

    </Container>
  );
};

export default About;
